<div class="container-fluid px-0 mt-4">
    <div class="row">
      <div class="col-12 col-lg-5 left-columm-menu">

        <div class="card p-4 border-0 rounded-8 box-shadow">
          <h1 class="blue-0041A3 font-size-24 font-solomon-bold mb-1"><i class="icon-settings mr-2"></i>Clientes</h1>
          <p class="gray-9EACB3 font-solomon font-size-14 mb-4">Configuración del cliente</p>
          <p class="gray-696969 font-solomon font-size-16">
            
          </p>
        </div>
        <h2 class="blue-0041A3 font-solomon-black font-size-16 mt-4 mb-3">
          Acciones disponibles
        </h2>

        <!-- component -->
        <div class="card border-0 box-shadow card-small-menu mb-3 active">
          <div class="row mx-0">
              <div class="col-2 col-lg-1 d-flex justify-content-center align-items-center icon-left">
                  <i class="icon-gift font-size-18"></i>
              </div>
              <div class="col-8 col-lg-9 pl-0">
                  <h3 class="font-solomon-bold font-size-16 mb-0">
                      Gestión clientes
                  </h3>
                  <p class="font-solomon font-size-12 mb-0">
                      Configuración de clientes
                  </p>
              </div>
              <div class="col-2 col-lg-2 d-flex justify-content-end align-items-center font-size-24 pr-4 link">
                  <a [routerLink]="['/organizations/']"><i class="icon-arrow_right"></i></a>
              </div>
          </div>
        </div>


          <!-- end component -->



      </div>
      <div class="col-12 col-lg-7">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>


